import { render, staticRenderFns } from "./MultipleUploadCard.vue?vue&type=template&id=179d563e&scoped=true"
import script from "./MultipleUploadCard.vue?vue&type=script&lang=ts"
export * from "./MultipleUploadCard.vue?vue&type=script&lang=ts"
import style0 from "./MultipleUploadCard.vue?vue&type=style&index=0&id=179d563e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d563e",
  null
  
)

export default component.exports